module.exports = __webpack_public_path__ + "static/media/wind_turbine_icon.2011a247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wind_turbine_icon.png
// module id = 689
// module chunks = 0